import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "love-it-alert",
    templateUrl: "./love-it-alert.component.html",
    styleUrls: ["./love-it-alert.component.scss"],
    standalone: false
})
export class LoveItAlertComponent implements OnInit {
  @Input() type: "info" | "success" | "danger" | "warning";

  icon: string;

  constructor() {}

  ngOnInit(): void {
    switch (this.type) {
      case "info":
        this.icon = "info";
        break;
      case "success":
        this.icon = "check-circle";
        break;
      case "danger":
        this.icon = "alert-octagon";
        break;
      case "warning":
        this.icon = "alert-triangle";
        break;
    }
  }
}
